/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { SalesStrictHttpResponse } from '../../sales-strict-http-response';
import { SalesRequestBuilder } from '../../sales-request-builder';

import { SalesContractPaymentResponseDto } from '../../models/sales-contract-payment-response-dto';

export interface ContractPaymentsControllerFindOne$Params {

/**
 * The tenant identifier.
 */
  tenant: string;

/**
 * The ID of the contract payment to retrieve.
 */
  id: string;
}

export function contractPaymentsControllerFindOne(http: HttpClient, rootUrl: string, params: ContractPaymentsControllerFindOne$Params, context?: HttpContext): Observable<SalesStrictHttpResponse<SalesContractPaymentResponseDto>> {
  const rb = new SalesRequestBuilder(rootUrl, contractPaymentsControllerFindOne.PATH, 'get');
  if (params) {
    rb.path('tenant', params.tenant, {});
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as SalesStrictHttpResponse<SalesContractPaymentResponseDto>;
    })
  );
}

contractPaymentsControllerFindOne.PATH = '/o2-sales/contract-payments/{tenant}/id/{id}';
